
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lQVoc", function(module, exports) {

$parcel$export(module.exports, "utils", function () { return $fe8af8a42c4a74bc$export$eab97d15b1788b8d; });

var $arQwb = parcelRequire("arQwb");
const $fe8af8a42c4a74bc$export$eab97d15b1788b8d = {
    n: function(e) {
        var n = new RegExp("(^|&)" + e + "=([^&]*)(&|$)"), t = window.location.search.substr(1).match(n);
        return t != null ? unescape(t[2]) : "";
    },
    t: function(e) {
        var t, n, e = e || {}, s = function() {
            t.readyState == 4 && (clearTimeout(n), t.status == 200 || t.status == 0 ? e.success && e.success(t.responseText) : e.error && e.error(t.responseText));
        };
        window.XMLHttpRequest ? t = new XMLHttpRequest : window.ActiveXObject && (t = new ActiveXObject("Microsoft.XMLHTTP")), t && (t.open(e.type, e.url), t.setRequestHeader("Content-type", "application/json"), t.onreadystatechange = s, e.data = e.data || null, t.send(e.data)), e.timeout && (n = setTimeout(function() {
            t.abort(), e.error && e.error(t.responseText);
        }, e.timeout));
    },
    setLocalData: function(key, obj) {
        window.localStorage.setItem(key, JSON.stringify(obj));
    },
    getLocalData: function(key) {
        if (window.localStorage.getItem(key)) {
            var str = window.localStorage.getItem(key);
            return JSON.parse(str);
        }
    },
    isInSight: function(el) {
        const bound = el.getBoundingClientRect();
        const clientHeight = window.innerHeight;
        //如果只考虑向下滚动加载
        //const clientWidth = window.innerWeight;
        return bound.top <= clientHeight + 100;
    },
    lazyload: function(imgs) {
        Array.from(imgs).forEach((el, i)=>{
            if ($fe8af8a42c4a74bc$export$eab97d15b1788b8d.isInSight(el)) (function(i) {
                setTimeout(function() {
                    var temp = imgs[i].getAttribute("data-img");
                    imgs[i].setAttribute("style", "background:url(" + temp + ") center center no-repeat;background-size:100%;");
                }, 500);
            })(i);
        });
    },
    historyRecord: function(obj) {
        var objArr = [];
        var myHistory = $fe8af8a42c4a74bc$export$eab97d15b1788b8d.getLocalData("my_history");
        if (myHistory) {
            objArr = JSON.parse(myHistory);
            if (objArr.length >= 16) objArr = objArr.splice(0, 15);
            if (myHistory && myHistory.indexOf(obj.id) >= 0) return false;
            objArr.unshift(obj);
        } else objArr.unshift(obj);
        $fe8af8a42c4a74bc$export$eab97d15b1788b8d.setLocalData("my_history", JSON.stringify(objArr));
    },
    readRecord: function() {
        var historyList = $fe8af8a42c4a74bc$export$eab97d15b1788b8d.getLocalData("my_history");
        var listHtml = "";
        if (historyList) {
            var hisList = JSON.parse(historyList);
            if (hisList.length >= 16) hisList = hisList.splice(0, 9);
            hisList.map((e)=>{
                listHtml += '<li class="items "><a href="info.html?id=' + e.id + '"><div class="items-img" data-img="' + (e.gameBigImage || "./images/default.png") + '"></div></a></li>';
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".recent-list").html(listHtml);
            var imgs = (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".items-img");
            $fe8af8a42c4a74bc$export$eab97d15b1788b8d.lazyload(imgs);
            (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".history").show();
        } else (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".history").hide();
    }
};

});


var $lQVoc = parcelRequire("lQVoc");

var $arQwb = parcelRequire("arQwb");
(function() {
    var e = "http://newgame.holyfinger.com:8083/api/";
    window.location.href.indexOf("https") >= 0 && (e = e.replace("http://newgame.holyfinger.com:8083", "https://newgame.holyfinger.com"));
    var loading = true;
    var isExpanded = false;
    var valParams = (0, $lQVoc.utils).n("searchTxt");
    (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(document).ready(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".ipt-search").change(function(e) {
            valParams = e.target.value;
            searchIpt();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".ipt-search").focus().val(valParams);
        (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".h-bg").click(function() {
            window.location.href = "./index.html";
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".item-l-4").hide();
        (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".btn-close").click(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".ipt-search").val("");
            (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".search").css("padding", "0.2rem 0.1rem").css("min-height", "auto");
            (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".list-search").empty();
            (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".no-search").show();
            (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".popular").show();
            (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".list-search").css("min-height", "auto");
        });
        (0, $lQVoc.utils).t({
            url: e + "ogame",
            type: "post",
            data: JSON.stringify({
                "channel": "crazegame",
                type: "Hot Games",
                page: 1
            }),
            timeout: 5e3,
            error: function() {},
            success: function(d) {
                var cardNode = (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".card");
                try {
                    if (d) {
                        var n = JSON.parse(d), t = n.data, l = t.splice(0, 1), gameList = t.splice(0, 2), gameList2 = t.splice(0, 3), ss = "", gameTxt = "";
                        cardNode.find(".title>a").attr("href", "/more.html?type=Hot Games");
                        cardNode.find(".lt>a").attr("href", "/info.html?id=" + l[0].id);
                        cardNode.find(".img1").attr("src", l[0].gamelogo);
                        cardNode.find(".txt").text(l[0].gamename);
                        gameList.map((e)=>{
                            gameTxt += '<a href="info.html?id=' + e.id + '"><img alt="" src="' + (e.gamelogo || "./images/default.png") + '" /><p><span class="txt">' + e.gamename + "</span></p></a>";
                        });
                        cardNode.find(".rt").html(gameTxt);
                        gameList2.map((e)=>{
                            ss += '<div class="item"><a href="info.html?id=' + e.id + '"><img alt="" src="' + (e.gamelogo || "./images/default.png") + '" /></a><p><span class="txt">' + e.gamename + "</span></p></div>";
                        });
                        cardNode.find(".box-game").html(ss);
                    }
                } catch  {}
            }
        });
        function searchIpt() {
            if (valParams.length == 0) {
                (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".no-search").text("NO GAMES WAS FOUND").show();
                (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".search").css("min-height", "auto").show();
                (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".list-search").hide();
                (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".empty-search").show().css("min-height", "29vh");
                return false;
            }
            (0, $lQVoc.utils).t({
                url: e + "gamesearch",
                type: "post",
                data: JSON.stringify({
                    "channel": "crazegame",
                    "name": valParams
                }),
                timeout: 5e3,
                error: function() {},
                success: function(e) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".list-search").empty();
                    try {
                        if (e) {
                            var n = JSON.parse(e), t = n.data, rtxt = "", ss = "";
                            if (t.length == 0) {
                                (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".popular").show();
                                (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".search").show();
                                (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".no-search").text("NO GAMES WAS FOUND").show();
                                (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".list-search").css("min-height", "auto");
                                return false;
                            } else {
                                (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".popular").hide();
                                (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".no-search").hide();
                                (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".list-search").show();
                                if (t.length <= 12) (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".list-search").css("min-height", "56vh");
                            }
                            t.map((e)=>{
                                ss += '<div class="item"><a href="info.html?id=' + e.id + '"><img alt="" src="' + (e.gamelogo || "./images/default.png") + '" /></a><p><span class="txt">' + e.gamename + "</span></p></div>";
                            }), (0, (/*@__PURE__*/$parcel$interopDefault($arQwb)))(".list-search").html(ss);
                        }
                    } catch  {}
                }
            });
        }
        searchIpt();
    });
})();


//# sourceMappingURL=search.39cbc21d.js.map
